import { Observable } from 'rxjs';

import {
  ICriticalityMetrics,
  IHistoryMetrics,
  IScoreMetrics,
  IStatusMetrics,
  IVentureHistoryMetrics,
  IVentureStatusMetrics,
} from '../interfaces/dashboard';
import apiService, { ApiService } from './api';

export class DashboardService {
  constructor(private apiService: ApiService) { }

  public getTotalsByStatus(): Observable<IStatusMetrics[]> {
    return this.apiService.get('/dashboard/totalsByStatus');
  }

  public getVenturesStatuses(): Observable<IVentureStatusMetrics[]> {
    return this.apiService.get('/dashboard/status');
  }

  public getVenturesHistory(): Observable<IVentureHistoryMetrics> {
    return this.apiService.get('/dashboard/statusByMonth');
  }

  public getStatus(ventureId?: number, entityId?: number): Observable<IVentureStatusMetrics> {
    let path = '/dashboard/status';
    if (ventureId) path += `/${ventureId}`;
    if (entityId) path += `/${entityId}`;
    return this.apiService.get(path);
  }

  public getCriticality(ventureId: number, entityId?: number): Observable<ICriticalityMetrics[]> {
    let path = `/dashboard/criticality/${ventureId}`;
    if (entityId) path += `/${entityId}`;
    return this.apiService.get(path);
  }

  public getScore(ventureId: number, entityId?: number): Observable<IScoreMetrics> {
    let path = `/dashboard/score/${ventureId}`;
    if (entityId) path += `/${entityId}`;
    return this.apiService.get(path);
  }

  public getHistory(ventureId?: number, entityId?: number): Observable<IHistoryMetrics> {
    let path = `/dashboard/statusByMonth/${ventureId}`;
    if (entityId) path += `/${entityId}`;
    return this.apiService.get(path);
  }
}

const dashboardService = new DashboardService(apiService);
export default dashboardService;